import PolicyPage from "./PolicyPage";

export default function PrivacyPolicy() {
  return (
    <PolicyPage title="Privacy policy" path="/privacy-policy">
      <p>This Privacy Policy explains how CreatorMic Pro (operated by CLSX LLC) collects, uses, and protects the personal information you provide.</p>
      <h2>What we collect</h2>
      <ul>
        <li>Contact details: name, email, phone, shipping/billing addresses.</li>
        <li>Order details: products purchased, order totals, payment status.</li>
        <li>Analytics: anonymized page views and device information.</li>
      </ul>
      <p>Payment information is processed by Stripe and PayPal — we never store card numbers on our servers.</p>
      <h2>How we use your information</h2>
      <ul>
        <li>To fulfill orders and send shipping notifications.</li>
        <li>To respond to your customer support inquiries.</li>
        <li>To improve our products and website performance.</li>
        <li>To send occasional marketing emails (opt-out any time from the footer of any email).</li>
      </ul>
      <h2>Cookies</h2>
      <p>We use essential cookies to remember your cart and preferences, and optional analytics cookies to understand traffic sources. You can control cookies in your browser settings.</p>
      <h2>Your rights</h2>
      <p>You may request a copy of your data or ask us to delete it any time by emailing <a href="mailto:support@creatormicpro.com" className="text-[#0066FF]">support@creatormicpro.com</a>.</p>
    </PolicyPage>
  );
}
